// Only user-facing copy is translated; sensor enums and API fields stay intact.
const JA_ACTIVITY_COPY = {
  "Fall & Activity Monitoring": "転倒・活動モニタリング",
  Back: "戻る",
  Online: "オンライン",
  Offline: "オフライン",
  Unknown: "不明",
  None: "なし",
  Good: "良好",
  Poor: "不良",
  Stable: "安定",
  Improving: "改善",
  Worsening: "悪化",
  Abnormality: "異常",
  "Room & Sensor Details": "部屋・センサー詳細",
  "Room & Device Details": "部屋・デバイス詳細",
  "Device Details": "デバイス詳細",
  "Edit Sensor Mapping": "センサー連携を編集",
  "Edit sensor mapping": "センサー連携を編集",
  "Delete Sensor Mapping?": "センサー連携を解除しますか？",
  "Delete sensor mapping": "センサー連携を解除",
  "Update the Sensor ID mapping.": "センサーIDの連携を更新します。",
  "This removes the sensor mapping for this account. You can add a sensor again at any time.":
    "このアカウントのセンサー連携を解除します。センサーはいつでも再登録できます。",
  "Sensor ID": "センサーID",
  "Device ID": "デバイスID",
  "Sensor Connection": "センサー接続",
  "Device Connection": "デバイス接続",
  "Last Sync": "最終同期",
  "Worn Status": "装着状態",
  Battery: "バッテリー",
  Gateway: "ゲートウェイ",
  "Data Quality": "データ品質",
  "Confidence level of bracelet sensor data from PacSana.":
    "PacSanaブレスレットセンサーのデータ信頼度です。",
  "Hardware Status": "ハードウェア状態",
  "Software Version": "ソフトウェアバージョン",
  "Last System Check": "最終システム確認",
  "No hardware issues detected.": "ハードウェアの問題は検出されていません。",
  "Hardware issue reported": "ハードウェアの問題が報告されています",
  "Not reported": "未報告",
  "Not yet reported": "未報告",
  "Restart Sensor": "センサーを再起動",
  "Restart Device": "デバイスを再起動",
  "Available after backend action is connected.":
    "バックエンド操作の接続後に利用できます。",
  "Fall History · Last 6 weeks": "転倒履歴・過去6週間",
  "Fall Detected": "転倒を検知",
  "Fall Suspected": "転倒の疑い",
  "Fall Recovered": "転倒から回復",
  "Not yet recovered": "未回復",
  "No falls recorded in the last 6 weeks.":
    "過去6週間に転倒の記録はありません。",
  "No alerts recorded": "アラートの記録はありません",
  "Alert History": "アラート履歴",
  "Hide History": "履歴を閉じる",
  Latest: "最新",
  "Last Alert:": "最終アラート：",
  "Activity Trend": "活動傾向",
  "View Activity Trend": "活動傾向を表示",
  "Hide Activity Trend": "活動傾向を閉じる",
  "No trend data available.": "利用可能な傾向データはありません。",
  "Last 14 days": "過去14日間",
  Day: "日",
  Legend: "凡例",
  From: "開始",
  To: "終了",
  Active: "活動",
  Sedentary: "安静",
  "Resident is currently:": "現在の利用者の状態：",
  "In Bed": "ベッド内",
  "In Couch": "ソファ上",
  "In Toilet Area": "トイレ内",
  "In Living Room": "リビング",
  Occupied: "在室",
  Vacant: "不在",
  Bed: "ベッド",
  Couch: "ソファ",
  Toilet: "トイレ",
  "Toilet Area": "トイレ",
  "Monitored Zones": "監視エリア",
  "No zones configured": "監視エリアは未設定です",
  "Monitoring area not yet configured": "監視エリアは未設定です",
  "Safety Perimeter": "安全範囲",
  "Fall Delay Threshold": "転倒判定待機時間",
  "{seconds} seconds": "{seconds}秒",
  "Time used to confirm a suspected fall before escalation.":
    "転倒の疑いを確定して通知するまでの待機時間です。",
  "Gait Decline": "歩行機能の低下",
  "Slowed Mobility": "移動速度の低下",
  "Night Wandering": "夜間徘徊",
  "Extended Toilet Stay": "トイレ滞在の長期化",
  "Unusual Night Activity": "通常と異なる夜間活動",
  "Prolonged Inactivity": "長時間の不活動",
  "No abnormalities detected": "異常は検出されていません",
  "No abnormalities detected.": "異常は検出されていません。",
  "Activity is within normal range.": "活動は通常範囲内です。",
  "No sustained deviation from this resident's personal baseline detected in bed or movement time.":
    "ベッド滞在時間や活動時間に、通常状態から継続的な変化は検出されていません。",
  "How it's measured": "測定方法",
  "> How it's measured": "測定方法を表示",
  "< Hide": "閉じる",
  "How it's defined": "定義を表示",
  "< Hide definition": "定義を閉じる",
  Cancel: "キャンセル",
  Close: "閉じる",
  Delete: "解除",
  Save: "保存",
  "Add Sensor": "センサーを追加",
};

const ZH_ACTIVITY_COPY = {
  "Fall & Activity Monitoring": "跌倒与活动监测",
  Back: "返回",
  Online: "在线",
  Offline: "离线",
  Unknown: "未知",
  None: "无",
  Good: "良好",
  Poor: "较差",
  Stable: "稳定",
  Improving: "改善",
  Worsening: "恶化",
  Abnormality: "异常",
  "Room & Sensor Details": "房间与传感器详情",
  "Room & Device Details": "房间与设备详情",
  "Device Details": "设备详情",
  "Edit Sensor Mapping": "编辑传感器关联",
  "Edit sensor mapping": "编辑传感器关联",
  "Delete Sensor Mapping?": "要解除传感器关联吗？",
  "Delete sensor mapping": "解除传感器关联",
  "Update the Sensor ID mapping.": "更新传感器 ID 关联。",
  "This removes the sensor mapping for this account. You can add a sensor again at any time.":
    "这将解除此账户的传感器关联。您可以随时重新添加传感器。",
  "Sensor ID": "传感器 ID",
  "Device ID": "设备 ID",
  "Sensor Connection": "传感器连接",
  "Device Connection": "设备连接",
  "Last Sync": "上次同步",
  "Worn Status": "佩戴状态",
  Battery: "电池",
  Gateway: "网关",
  "Data Quality": "数据质量",
  "Confidence level of bracelet sensor data from PacSana.":
    "PacSana 手环传感器数据的可信度。",
  "Hardware Status": "硬件状态",
  "Software Version": "软件版本",
  "Last System Check": "上次系统检查",
  "No hardware issues detected.": "未检测到硬件问题。",
  "Hardware issue reported": "已报告硬件问题",
  "Not reported": "未报告",
  "Not yet reported": "尚未报告",
  "Restart Sensor": "重启传感器",
  "Restart Device": "重启设备",
  "Available after backend action is connected.": "后端操作接入后即可使用。",
  "Fall History · Last 6 weeks": "跌倒记录 · 最近 6 周",
  "Fall Detected": "检测到跌倒",
  "Fall Suspected": "疑似跌倒",
  "Fall Recovered": "已从跌倒中恢复",
  "Not yet recovered": "尚未恢复",
  "No falls recorded in the last 6 weeks.": "最近 6 周没有跌倒记录。",
  "No alerts recorded": "没有警报记录",
  "Alert History": "警报记录",
  "Hide History": "收起记录",
  Latest: "最新",
  "Last Alert:": "上次警报：",
  "Activity Trend": "活动趋势",
  "View Activity Trend": "查看活动趋势",
  "Hide Activity Trend": "收起活动趋势",
  "No trend data available.": "暂无趋势数据。",
  "Last 14 days": "最近 14 天",
  Day: "日",
  Legend: "图例",
  From: "开始",
  To: "结束",
  Active: "活动",
  Sedentary: "静坐",
  "Resident is currently:": "住户当前状态：",
  "In Bed": "在床上",
  "In Couch": "在沙发上",
  "In Toilet Area": "在卫生间",
  "In Living Room": "在客厅",
  Occupied: "有人",
  Vacant: "无人",
  Bed: "床",
  Couch: "沙发",
  Toilet: "卫生间",
  "Toilet Area": "卫生间",
  "Monitored Zones": "监测区域",
  "No zones configured": "未配置监测区域",
  "Monitoring area not yet configured": "尚未配置监测区域",
  "Safety Perimeter": "安全范围",
  "Fall Delay Threshold": "跌倒确认等待时间",
  "{seconds} seconds": "{seconds} 秒",
  "Time used to confirm a suspected fall before escalation.":
    "在上报前用于确认疑似跌倒的等待时间。",
  "Gait Decline": "步态下降",
  "Slowed Mobility": "行动变慢",
  "Night Wandering": "夜间游走",
  "Extended Toilet Stay": "如厕停留时间延长",
  "Unusual Night Activity": "夜间活动异常",
  "Prolonged Inactivity": "长时间不活动",
  "No abnormalities detected": "未检测到异常",
  "No abnormalities detected.": "未检测到异常。",
  "Activity is within normal range.": "活动处于正常范围内。",
  "No sustained deviation from this resident's personal baseline detected in bed or movement time.":
    "卧床时间和活动时间均未检测到相对于该住户个人基线的持续偏离。",
  "How it's measured": "测量方法",
  "> How it's measured": "查看测量方法",
  "< Hide": "收起",
  "How it's defined": "查看定义",
  "< Hide definition": "收起定义",
  Cancel: "取消",
  Close: "关闭",
  Delete: "解除",
  Save: "保存",
  "Add Sensor": "添加传感器",
};

const ACTIVITY_COPY = { ja: JA_ACTIVITY_COPY, zh: ZH_ACTIVITY_COPY };

// Templated strings: [pattern, ja(match), zh(match)].
const ACTIVITY_PATTERNS = [
  [/^(\d+) min ago$/, (m) => `${m[1]}分前`, (m) => `${m[1]} 分钟前`],
  [/^(\d+)s ago$/, (m) => `${m[1]}秒前`, (m) => `${m[1]} 秒前`],
  [/^(\d+) min$/, (m) => `${m[1]}分`, (m) => `${m[1]} 分钟`],
  [/^(\d+) seconds$/, (m) => `${m[1]}秒`, (m) => `${m[1]} 秒`],
  [
    /^(\d+) of (\d+) weeks$/,
    (m) => `${m[2]}週中${m[1]}週`,
    (m) => `第 ${m[1]} 周，共 ${m[2]} 周`,
  ],
  [/^(\d+) hr(?:s)? ago$/, (m) => `${m[1]}時間前`, (m) => `${m[1]} 小时前`],
  [
    /^(\d+) of (\d+) days$/,
    (m) => `${m[2]}日中${m[1]}日`,
    (m) => `${m[2]} 天中有 ${m[1]} 天`,
  ],
  [
    /^(\d+) of (\d+) nights$/,
    (m) => `${m[2]}晩中${m[1]}晩`,
    (m) => `${m[2]} 晚中有 ${m[1]} 晚`,
  ],
  [
    /^Recovered in (\d+) min$/,
    (m) => `${m[1]}分で回復`,
    (m) => `${m[1]} 分钟内恢复`,
  ],
  [
    /^Monitoring area configured · height (.+) cm$/,
    (m) => `監視エリア設定済み・高さ ${m[1]} cm`,
    (m) => `已配置监测区域 · 高度 ${m[1]} cm`,
  ],
];

const NON_DISPLAY_KEYS = new Set([
  "id",
  "key",
  "internal",
  "state",
  "type",
  "kind",
  "tone",
  "color",
  "signal",
  "direction",
  "trend",
  "severity",
  "alertState",
  "previousState",
  "renderIf",
  "method",
  "path",
  "url",
]);

const localizeActivityText = (value, locale) => {
  const copy = ACTIVITY_COPY[locale];
  if (!copy || typeof value !== "string") return value;
  if (copy[value]) return copy[value];

  const normalized = value.replace(/_/g, " ").toLowerCase();
  const normalizedMatch = Object.entries(copy).find(
    ([source]) => source.toLowerCase() === normalized,
  );
  if (normalizedMatch) return normalizedMatch[1];

  for (const [pattern, ja, zh] of ACTIVITY_PATTERNS) {
    const match = value.match(pattern);
    if (match) return locale === "zh" ? zh(match) : ja(match);
  }
  return value;
};

const localizeActivityTree = (value, locale, parentKey = "") => {
  if (typeof value === "string") {
    return NON_DISPLAY_KEYS.has(parentKey)
      ? value
      : localizeActivityText(value, locale);
  }
  if (Array.isArray(value)) {
    return value.map((item) => localizeActivityTree(item, locale, parentKey));
  }
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [
        key,
        localizeActivityTree(item, locale, key),
      ]),
    );
  }
  return value;
};

const formatActivityClock = (value, locale) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleTimeString(locale || undefined, {
    hour: "numeric",
    minute: "2-digit",
  });
};

const formatActivityWeekPosition = (current, total, locale) =>
  localizeActivityText(`${current} of ${total} weeks`, locale);

export {
  formatActivityClock,
  formatActivityWeekPosition,
  localizeActivityText,
  localizeActivityTree,
};
